<i18n>
{
	"en": {
		"title": "Loading Sequence",
		"save": "Save"
	},
	"no": {
		"title": "Lasterekkefølge",
		"save": "Lagre"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:title="$t('title')"
		icon="order"
		iconColor="blue"
		:width="width"
		@close="$emit('close')"
		@shown="processShown"
	>
		<div class="dialog-mid">
			<draggable
				v-model="orders"
				v-bind="dragOptions"
				@start="dragging=true"
				@end="dragging=false"
			>
				<transition-group type="transition" :name="!dragging ? 'flip-list' : null" style="flex-direction: column">
					<t-order-card
						v-for="order in orders"
						:key="order.id"
						style="margin: 0px 3px 20px 3px; display: inline-block; cursor: move!important"
						:disableHover="dragging"
						:orderHeader="getOrderHeader(order)"
						:orderNumber="order.orderNumber"
						:orderIcon="getOrderIcon(order)"
						:orderIconColor="getStatusColor(order.status)"
						:order="order"
					/>
				</transition-group>
			</draggable>
		</div>
		<template v-slot:footer>
			<t-button
				appearance="primary"
				class="timpex-modal-button"
				width="100%"
				@click="save"
			>
				{{$t('save')}}
			</t-button>
		</template>
	</t-dialog>
</template>
<script>
import {
	statuses, goodsTypesIcons
} from '@/core';
import draggable from 'vuedraggable';
import deepCopy from 'deepcopy';

export default {
	name: 'ChangeLoadingSequence',
	components: { draggable },
	props: {
		isShown: Boolean,
		trip: Object
	},
	data() {
		return {
			orders: [],
			dragging: false
		};
	},
	computed: {
		disableSave() {
			return !this.trip || !this.trip.tripNumber;
		},
		dragOptions() {
			return {
				animation: 200,
				group: 'description',
				disabled: false,
				ghostClass: 'ghost'
			};
		},
		width() {
			let min = 772;
			let expand = 0;
			if (this.tripOrders) expand = Math.floor(this.tripOrders.length / 9);
			return `${min + (252 * expand)}px`;
		},
		tripOrders() {
			return this.trip && this.trip.orders ? this.trip.orders : [];
		}
	},
	methods: {
		processShown() {
			this.orders = deepCopy(this.trip.orders).sort((a,b) => {
				let aNum = isNaN(a.loadingSeqNo) ? Number.MAX_SAFE_INTEGER : a.loadingSeqNo;
				let bNum = isNaN(b.loadingSeqNo) ? Number.MAX_SAFE_INTEGER : b.loadingSeqNo;
				return aNum - bNum;
			});
		},
		save() {
			let newSequence = {};
			for (let i = 0; i < this.orders.length; i++) {
				newSequence[this.orders[i].id] = i;
			}
			this.$emit('changeLoadingSequence', newSequence);
		},
		getOrderHeader(order) {
			return order.customer ? order.customer.name : '';
		},
		getStatusColor(status) {
			return statuses.color(status);
		},
		getOrderIcon(order) {
			return goodsTypesIcons(order.goodsType);
		},
	},
};
</script>

<style >
.flip-list-move {
	transition: transform 0.5s;
}
.no-move {
	transition: transform 0s;
}
.ghost {
	opacity: 0.5;
	background: #c8ebfb;
}

</style>

<style lang="scss" scoped>

</style>
